module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-2-Australia-Landing-Page-w720.6c6a674f.webp";